import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=150f939c&scoped=true&"
import script from "./Attachment.vue?vue&type=script&lang=js&"
export * from "./Attachment.vue?vue&type=script&lang=js&"
import style0 from "./Attachment.vue?vue&type=style&index=0&id=150f939c&scoped=true&lang=css&"
import style1 from "../../constant/css/detail.css?vue&type=style&index=1&id=150f939c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150f939c",
  null
  
)

export default component.exports